<section class="payment-modal">
  <button class="payment-modal__close" type="button" aria-label="Cerrar pago" (click)="modal.close()">×</button>
  <app-izipay-checkout [orderId]="purchase.orderId()" [amount]="totalAmount" (paid)="onPaid($event)" />
</section>